module.exports = __webpack_public_path__ + "static/media/add-record-to-cors.286ff65d.gif";